var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoteToCustomer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9 10h12V9H9zm0 6h10v-1H9zm0-3h8v-1H9zm13-6H8a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h8l-2 4 6-4h2a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1"
})));
export default SvgNoteToCustomer;